import React, {Component} from "react";
import {Alert, FormGroup, Row, Col, Label, Modal, Button} from "reactstrap";
import {Formik, Field, Form, ErrorMessage} from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import {usersNew, usersEdit} from "../../store/users/actions";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {capitalizeFirst, removeEmptyFormField} from "../../common/general";

class NewModal extends Component {
  constructor(props) {
    super(props)
    this.state = {loading: false, error: ""}
  }

  onClose = () => {
    this.props.togModal()
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({loading: this.props.loading, response: this.props.response, error: this.props.error});
      if (this.props.response.status === 0) {
        this.props.usersRefresh({history: this.props.history})
        this.onClose()
      }
    }
  }

  render() {
    const requiredUsername = Yup.string().required("Please enter your username")
    const requiredEmail = Yup.string().required("Please enter your email")
    const requiredPassword = Yup.string().required('Please enter your password')

    return (<React.Fragment>
      <Modal isOpen={true} toggle={this.onClose}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            {capitalizeFirst(this.props.action)} User
          </h5>
          <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <Formik
          initialValues={{
            username: this.props.action === "new" ? "" : this.props.userData.username,
            email: this.props.action === "new" ? "" : this.props.userData.email,
            password: "",
          }}
          validationSchema={Yup.object().shape({
            username: Yup.string().min(3, 'Username is too short').max(32, 'Username is too long').concat(this.props.action === "new" ? requiredUsername : null),
            email: Yup.string().email('Please enter valid email').concat(this.props.action === "new" ? requiredEmail : null),
            password: Yup.string().min(8, 'Password is too short').max(32, 'Password is too long').concat(this.props.action === "new" ? requiredPassword : null),
          })}
          onSubmit={values => {
            const {onUsersNew, onUsersEdit} = this.props
            if (this.props.action === "new") {
              onUsersNew({history: this.props.history, values: values})
            } else {
              onUsersEdit({history: this.props.history, id: this.props.userData.id, values: removeEmptyFormField(values)})
            }
          }}
        >
          {({errors, status, touched}) => (<Form>
            <div className="modal-body">
              <Row>
                <Col lg="12" className="mb-1">
                  <FormGroup>
                    <Label htmlFor="username">
                      Username
                    </Label>
                    <Field
                      id="username"
                      name="username"
                      placeholder="Enter your username"
                      type="text"
                      className={"form-control" + (errors.username && touched.username ? " is-invalid" : "")}
                    />
                    <ErrorMessage
                      name="username"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col lg="12" className="mb-1">
                  <FormGroup>
                    <Label htmlFor="email">
                      Email
                    </Label>
                    <Field
                      id="email"
                      name="email"
                      placeholder="Enter your email"
                      type="text"
                      className={"form-control" + (errors.email && touched.email ? " is-invalid" : "")}
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col lg="12" className="mb-1">
                  <FormGroup>
                    <Label htmlFor="password">
                      Password
                    </Label>
                    <Field
                      id="password"
                      name="password"
                      placeholder="Enter your password"
                      type="password"
                      className={"form-control" + (errors.password && touched.password ? " is-invalid" : "")}
                    />
                    <ErrorMessage
                      name="password"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </div>
            <div className="modal-footer">
              {this.state.loading && (<div className="spinner-border text-primary m-1 me-auto" role="status">
                <span className="sr-only">Loading...</span>
              </div>)}
              {this.state.error.length > 0 && (<Alert color="danger" role="alert" className="me-auto">
                {this.state.error}
              </Alert>)}
              <Button color="secondary" onClick={this.onClose} data-dismiss="modal">
                Close
              </Button>
              <Button color="primary" type="submit">
                Save
              </Button>
            </div>
          </Form>)}
        </Formik>
      </Modal>
    </React.Fragment>)
  }
}

NewModal.propTypes = {
  response: PropTypes.any,
  onUsersNew: PropTypes.func,
  onUsersEdit: PropTypes.func,
};

const mapStateToProps = ({Users}) => ({
  response: Users.responseNew,
  loading: Users.loadingNew,
  error: Users.errorNew,
});

const mapDispatchToProps = dispatch => ({
  onUsersNew: data => dispatch(usersNew(data)),
  onUsersEdit: data => dispatch(usersEdit(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(NewModal));